import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';

import { computeBarWidthRatio } from '@v2/pages/dashboard/common/helpers';

import { DashboardListBarVariant, DashboardListBarAnchor } from './types';
import { COLOR_BY_VARIANT } from './constants';

interface DashboardListBarProps extends WithColor {
  seconds: number;
  maxSeconds: number | null;
  variant: DashboardListBarVariant;
  anchor?: DashboardListBarAnchor;
  valueText?: string;
}

const DashboardListBar: FC<DashboardListBarProps> = ({
  C,
  seconds,
  maxSeconds,
  variant,
  anchor = DashboardListBarAnchor.Left,
  valueText,
}) => {
  const ratio = computeBarWidthRatio(seconds, maxSeconds);
  const colorKey = COLOR_BY_VARIANT[variant];
  const isLeftAnchor = anchor === DashboardListBarAnchor.Left;

  const spacer = <View style={{ flex: 1 - ratio }} />;
  const bar = (
    <View
      style={{
        flex: ratio,
        height: scale(ROW_LAYOUT.bar.height),
        backgroundColor: C(colorKey),
        borderRadius: scale(4),
      }}
    />
  );
  const label = valueText ? <Text style={[font['Caption Rounded'], { color: C(colorKey) }]}>{valueText}</Text> : null;

  return (
    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', gap: scale(8) }}>
      {isLeftAnchor ? (
        <>
          {bar}
          {label}
          {spacer}
        </>
      ) : (
        <>
          {spacer}
          {label}
          {bar}
        </>
      )}
    </View>
  );
};

export default ColorWrapper(DashboardListBar);
